// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__XtvD1","nav":"Footer_nav__KcUhK","affiliate":"Footer_affiliate__Oapmz"};